import styles from "./CoHostList.module.scss";
import React from "react";
import _ from "lodash";
import { CoHost } from "../../api";

export interface CoHostListProps {
    cohosts: Array<CoHost>;
    onRemove: (email: string) => Promise<void>;
}

const CoHostItem = (coHost: CoHost, onRemove: (email: string) => Promise<void>) => {
    const remove = () => {
        if (confirm(`Remove ${coHost.email}?`)) {
            onRemove(coHost.email);
        }
    };
    return (
        <li className={styles["cohost-item"]} key={coHost.email}>
            {coHost.email}
            <span className={styles["cohost-remove"]} onClick={remove}>X</span>
        </li>
    );
}


export const CoHostList = (props: CoHostListProps) => {
    if (props.cohosts.length == 0) {
        return null;
    }

    return (
        <div>
            <h2>Current CoHosts</h2>
            <ul className={styles["cohost-list-container"]}>
                {_.map(props.cohosts, (coHost: CoHost) => {return CoHostItem(coHost, props.onRemove);})}
            </ul>
        </div>
    );
}

export default CoHostList;
